export default {

    name: 'AppLogo',

    render()
    {
        return (
            <div class="app-logo">
                <RouterLink to="/">
                    <b>sx</b><i>api</i>
                </RouterLink>
            </div>
        );
    }
}